import { render, staticRenderFns } from "./NumberRangeItem.vue?vue&type=template&id=3dcefb4c&scoped=true"
import script from "./NumberRangeItem.vue?vue&type=script&lang=js"
export * from "./NumberRangeItem.vue?vue&type=script&lang=js"
import style0 from "./NumberRangeItem.vue?vue&type=style&index=0&id=3dcefb4c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcefb4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dcefb4c')) {
      api.createRecord('3dcefb4c', component.options)
    } else {
      api.reload('3dcefb4c', component.options)
    }
    module.hot.accept("./NumberRangeItem.vue?vue&type=template&id=3dcefb4c&scoped=true", function () {
      api.rerender('3dcefb4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/NumberRangeItem.vue"
export default component.exports